import { useState, useEffect } from "preact/hooks";

export function useCheckScrollSpeedX({ scrollLeft }: { scrollLeft: number }) {
  const [lastScrollValueX, setLastScrollValueX] = useState<number | null>(null);
  const [currentScrollValueX, setCurrentScrollValueX] = useState<number | null>(
    null,
  );
  const [delta, setDelta] = useState(0);

  useEffect(() => {
    if (scrollLeft !== currentScrollValueX) {
      setCurrentScrollValueX(scrollLeft);
    }
  }, [scrollLeft, currentScrollValueX]);

  useEffect(() => {
    if (currentScrollValueX && currentScrollValueX !== lastScrollValueX) {
      setLastScrollValueX(currentScrollValueX);
    }
  }, [currentScrollValueX, lastScrollValueX]);

  useEffect(() => {
    if (currentScrollValueX && lastScrollValueX) {
      if (currentScrollValueX !== lastScrollValueX) {
        setDelta(currentScrollValueX - lastScrollValueX);
      }
    }

    const clear = () => {
      setLastScrollValueX(null);
    };
    const scrollSpeedTimer = setTimeout(clear, 100);
    return clearTimeout(scrollSpeedTimer);
  }, [currentScrollValueX, lastScrollValueX]);

  return delta;
}
